/**
 * AccountSelectorScreen — multi-identità (v1.5)
 *
 * Mostrato al boot quando il device ospita PIÙ identità (sigil). L'utente sceglie
 * quale sbloccare (→ setActiveSigil + /pin-unlock) oppure ne crea una nuova
 * (→ /welcome, flusso su invito). Lo stato FS è namespaced per sigil (fsStore),
 * quindi cambiare identità NON mischia i ratchet.
 */

import { useNavigate } from 'react-router-dom';
import { Frame, Header, Footer, Btn } from '../components/Frame';
import { loadAccounts, setActiveSigil } from '../lib/pinCrypto';

export default function AccountSelectorScreen() {
  const navigate = useNavigate();
  const accounts = loadAccounts();

  function pick(sigil) {
    setActiveSigil(sigil);
    navigate('/pin-unlock', { replace: true });
  }

  return (
    <Frame statusLeft="IDENTITÀ" statusRight="5G">
      <Header title="// Scegli identità" crumb={`[${accounts.length}]`} />

      <p className="text-[14px] text-ink-dim mb-3">
        Questo dispositivo ha più identità. Ognuna è separata: chat, contatti e
        chiavi non si mescolano.
      </p>

      <div className="space-y-2 mb-4">
        {accounts.map((a) => (
          <button
            key={a.sigil.toLowerCase()}
            onClick={() => pick(a.sigil)}
            className="w-full flex items-center justify-between gap-3 border border-ink-dim/50 rounded-xl bg-ink/[0.02] px-4 py-3 text-left hover:bg-ink/[0.07] active:bg-ink/[0.12] transition-colors"
          >
            <span className="font-mono text-[17px] text-ink text-glow truncate">
              @{a.sigil}
            </span>
            {a.tor && (
              <span className="shrink-0 text-[11px] text-amber border border-amber/50 rounded-md px-1.5 py-0.5">
                🧅 Tor-only
              </span>
            )}
          </button>
        ))}
      </div>

      <Footer>
        <Btn
          variant="ghost"
          onClick={() => {
            // Intento esplicito: crea una NUOVA identità anche se sul device c'è
            // già un backup (altrimenti l'InviteScreen offrirebbe "Sblocca").
            try { sessionStorage.setItem('nullum.wantNewIdentity', '1'); } catch {}
            navigate('/welcome');
          }}
        >
          ＋ Nuova identità
        </Btn>
        <Btn variant="ghost" onClick={() => navigate('/recover')}>
          Ho perso il PIN — uso le 24 parole
        </Btn>
      </Footer>
    </Frame>
  );
}
